import { useEffect, useState } from "react";
export var getDate = function getDate(initState) {
  if (initState) {
    return new Date(initState).toLocaleDateString("en-GB").replaceAll("/", ".");
  }

  return "";
};
export var useValidationDate = function useValidationDate(initState) {
  if (initState === void 0) {
    initState = "";
  }

  var _useState = useState(getDate(initState)),
    value = _useState[0],
    setValue = _useState[1];

  var _useState2 = useState(initState ? true : false),
    isValidDate = _useState2[0],
    setValidDate = _useState2[1];

  var _useState3 = useState(null),
    date = _useState3[0],
    setDate = _useState3[1];

  useEffect(
    function () {
      if (isValidDate) {
        var newDate = value.split(".").reverse().join("-");
        if (new Date(newDate).toLocaleDateString("en-GB") === "Invalid Date") setValidDate(false);
        else setDate(new Date(newDate));
      } else setDate(null);
    },
    [isValidDate, value]
  );

  var handleDateChange = function handleDateChange(evt) {
    var value = evt.target.value;
    setValue(value);
    if (value.length >= 10) setValidDate(true);
    else setValidDate(false);
  };

  return [value, handleDateChange, date, isValidDate, setValue];
};
